/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Section_CreateInputs */



/**
* | output |
* | --- |
* | "Create" |
*
* @param {Nav_Section_CreateInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const nav_section_create = /** @type {((inputs?: Nav_Section_CreateInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Section_CreateInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Erstellen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Créer")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("创作")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("創作")
	if (locale === "ko") return /** @type {LocalizedString} */ ("만들기")
	return /** @type {LocalizedString} */ ("Create")
});